'use client'

import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // 에러를 로깅 서비스에 전송
    console.error('App error:', error)
  }, [error])

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-900 to-gray-900 flex items-center justify-center p-3 xxs:p-4">
      <div className="max-w-lg w-full">
        <div className="text-center">
          {/* 에러 일러스트 */}
          <div className="mb-4 xxs:mb-6 sm:mb-8">
            <svg className="w-20 h-20 xxs:w-24 xxs:h-24 sm:w-32 sm:h-32 mx-auto text-blue-500/20" viewBox="0 0 200 200">
              <circle cx="100" cy="100" r="80" fill="currentColor" />
              <text x="100" y="120" fontSize="80" textAnchor="middle" className="fill-blue-400">
                :(
              </text>
            </svg>
          </div>

          <h1 className="text-xl xxs:text-2xl sm:text-4xl font-bold text-white mb-2 xxs:mb-3 sm:mb-4">
            앗, 뭔가 잘못되었어요
          </h1>

          <p className="text-sm xxs:text-base sm:text-lg text-gray-400 mb-5 xxs:mb-6 sm:mb-8">
            일시적인 문제가 발생했습니다.<br />
            새로고침하거나 잠시 후 다시 시도해주세요.
          </p>

          <div className="flex gap-2 xxs:gap-3 sm:gap-4 justify-center">
            <button
              onClick={reset}
              className="px-4 xxs:px-5 sm:px-6 py-2 xxs:py-2.5 sm:py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white text-sm xxs:text-base font-semibold rounded-lg shadow-lg transform transition-all hover:scale-105"
            >
              다시 시도하기
            </button>

            <button
              onClick={() => window.location.href = '/'}
              className="px-4 xxs:px-5 sm:px-6 py-2 xxs:py-2.5 sm:py-3 bg-slate-700 hover:bg-slate-600 text-white text-sm xxs:text-base font-semibold rounded-lg shadow-lg transition-colors"
            >
              홈으로 가기
            </button>
          </div>

          {/* 에러 코드 (있을 경우) */}
          {error.digest && (
            <p className="mt-5 xxs:mt-6 sm:mt-8 text-[10px] xxs:text-xs text-gray-600">
              에러 코드: {error.digest}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}